export const COLLAPSE_ANIMATION =
  'width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, height 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, padding 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, margin 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, opacity 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, max-width 225ms cubic-bezier(0.4, 0, 0.6, 1), transform 150ms cubic-bezier(0.4, 0, 0.6, 1) 0ms'

export const DRAWER_EXPANDED_WIDTH = 220
export const DRAWER_COLLAPSED_WIDTH = 52
